<template>
    <div class="lang">
        <div class="info">
            <h3 class="bullet01">Амбулаторид бүртгүүлэх, ажлын цаг</h3>
            <p class="depth">Үзлэгийн цагийг утсаар, и-мэйлээр, вебсайтаар захиалж болно. Үзлэг болон эмчилгээний цаг захиалахын тулд хувийн мэдээллээ өгч, өвчний шинж тэмдгээ дэлгэрэнгүй тайлбарлах хэрэгтэй.</p>
            <div class="table mt20">
                <table>
                    <colgroup>
                        <col style="width: 25%">
                        <col style="width: auto">
                        <col style="width: 15%">
                    </colgroup>
                    <thead>
                        <tr>
                            <th scope="col">Цаг захиалах заавар	</th>
                            <th scope="col">Дэс дараа</th>
                            <th scope="col">Захиалах боломжтой цаг</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Утасны дугаар</td>
                            <td>Олон улсын эмчилгээний төв (+82-6986-5894) дугаар луу залгаж цаг захиалах боломжтой.</td>
                            <td>08:30 ~ 16:30</td>
                        </tr>
                        <tr>
                            <td>Цахим шуудан</td>
                            <td><a href="mailto:ewha.mongol@gmail.com">ewha.mongol@gmail.com</a></td>
                            <td>24 цаг</td>
                        </tr>
                        <tr>
                            <td>Веб хуудас</td>
                            <td>
                                <div style="display: ruby;">
                                    эмнэлгийн цахим хуудаснаас цаг захиалах боломжтой.
                                    &nbsp;&nbsp;
                                    <a href="/mongol/reservation/reservation.do"
                                        class="main-button small c-main">Шууд очих</a>
                                </div>
                            </td>
                            <td>24 цаг</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="info">
            <h3 class="bullet01">Үзлэгийн өдөр(захиалга) өөрчлөх болон цуцлах</h3>
            <p class="depth">
                Амбулаторид үзүүлэхээр цаг захиалсан үйлчлүүлэгч хүндэтгэх шалтгаанаар тухайн өдрөө үзүүлэх боломжгүй болсон бол нэг өдрийн өмнө утсаар ярьж үзүүлэх өдрөө өөрчлөх юм уу цуцлах боломжтой.
            </p>
            <div class="table mt20">
                <table>
                    <colgroup>
                        <col style="width: 25%;">
                        <col>
                    </colgroup>
                    <thead>
                        <tr>
                            <th scope="col">Цаг захиалах заавар</th>
                            <th scope="col">Дэс дараа</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Утасны дугаар</td>
                            <td>Олон улсын эмчилгээний төв (+82-6986-5894) дугаар луу залгаж цаг захиалах боломжтой.</td>
                        </tr>
                        <tr>
                            <td>Цахим шуудан</td>
                            <td><a href="mailto:ewha.mongol@gmail.com">ewha.mongol@gmail.com</a></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>